import type { ComponentProps } from 'react';

import { cn } from '@/lib/utils';

export type PaginationContentProps = ComponentProps<'ul'>;

const PaginationContent = ({ className, ...props }: PaginationContentProps) => {
  return (
    <ul
      data-slot="pagination-content"
      className={cn('flex items-center gap-0.5 list-none!', className)}
      {...props}
    />
  );
};

export default PaginationContent;
